/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Price_Once_NoteInputs */

const es_landing_price_once_note = /** @type {(inputs: Landing_Price_Once_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lo único que pagas antes de poder alquilar.`)
};

const gl_landing_price_once_note = /** @type {(inputs: Landing_Price_Once_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O único que pagas antes de poder alugar.`)
};

const en_landing_price_once_note = /** @type {(inputs: Landing_Price_Once_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The only thing you pay before you can rent out.`)
};

/**
* | output |
* | --- |
* | "The only thing you pay before you can rent out." |
*
* @param {Landing_Price_Once_NoteInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_price_once_note = /** @type {((inputs?: Landing_Price_Once_NoteInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Price_Once_NoteInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_price_once_note(inputs)
	if (locale === "en") return en_landing_price_once_note(inputs)
	return es_landing_price_once_note(inputs)
});